export default __webpack_public_path__ + "static/media/k6.21228b9d.jpg";